import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { SelectOption } from "src/types/common";
import { client } from '../../utils/axios-client';
import { useQuery } from '@tanstack/react-query';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name: string, personName: readonly string[], theme: Theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}



const loadOptions = () => client.get(`/api/options/STAGE`).then((res) => res.data);


type Props = {
    value: string[],
    onChange: (newValue: string[]) => void
}

const OutcomeStageList = ({ value, onChange }: Props) => {
    const theme = useTheme();
    const { data, isLoading, isError, error: fetchError, refetch } = useQuery<SelectOption[]>({
        queryKey: ['stageOptions'],
        queryFn: () => loadOptions()
    });


    const handleChange = (event: SelectChangeEvent<string[]>) => {
        const {
            target: { value },
        } = event;

        onChange(typeof value === 'string' ? value.split(',') : value,);
    };

    if (!data) return null;

    return (
        <FormControl sx={{ width: '100%', height: '100%' }} size="small">
            <InputLabel id="stages-label">Stages</InputLabel>
            <Select
                labelId="stages-label"
                multiple
                fullWidth
                value={value}
                onChange={handleChange}
                input={<OutlinedInput size="small" id="select-multiple-chip" label="Stages" sx={{height: '100%', alignItems: 'start'} } />}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                        {selected.map((value: string) => (
                            <Chip size="small" key={value} label={data.find(s => s.value === value)?.name} />
                        ))}
                    </Box>
                )}
                MenuProps={MenuProps}
            >
                {data.map((stage) => (
                    <MenuItem
                        key={stage.value}
                        value={stage.value}
                    >
                        {stage.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default OutcomeStageList;